export default __webpack_public_path__ + "static/BT_Benefits_Carousel_07-a22d17c9245badfe8fce15c9848403ef.jpg";